import { useState, useEffect, useRef } from "react";
import { FiMenu, FiX, FiChevronDown, FiChevronRight, FiUser, FiLogOut } from 'react-icons/fi';
import Logo1 from "../../assets/logo-5.png";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { HeaderData } from "../apis/Headerdata";
import { encryptID } from '../apis/cryptoUtils';
import { postLead } from "../apis/LeadAPI";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";


const commonStyles = {
  mobiledrop: "block px-4 py-2 text-white hover:bg-gray-100 hover:text-gray-900",
  header: "absolute w-full z-50 py-4 transition-all duration-300",
  container: "px-4 max-w-7xl mx-auto sm:px-6 lg:px-8 ",
  logo: "flex rounded outline-none",
  menuIcon: "w-7 h-7",
  navLink:
    "text-base font-medium text-gray-900 transition-all duration-200 text-white",
  button:
    "inline-flex items-center justify-center px-4 py-2 text-lg text-white transition-all duration-200 border border-transparent rounded-lg",
  primaryButton: "bg-darkBlue",
  secondaryButton:
    "bg-transparent border-gray-900 hover:bg-gray-900 hover:text-white",
  sectionTitle:
    "text-5xl font-bold leading-tight text-black sm:text-5xl sm:leading-tight lg:text-5xl lg:leading-tight font-pj",
  textAccent: "relative inline-flex sm:inline",
  textHighlight:
    "bg-gradient-to-r from-[#44BCFF] via-[#FF44EC] to-[#FF675E] blur-lg filter opacity-30 w-full h-full absolute inset-0",
  dropdown:
    "absolute md:mt-10 left-1/2 transform -translate-x-1/2 bg-darkBlue shadow-lg rounded-md py-2 w-[90vw] max-w-screen-2xl  z-20",
  dropdownItem:
    "block px-4 py-2 text-white hover:bg-white hover:text-darkBlue",
  dropdownNested: "absolute bg-white shadow-lg top-0 left-full mt-0 ml-2 w-56 z-30",
  nestedDropdownItem:
    "block px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900",
  dropdownVisible:
    "block opacity-100 transition-opacity duration-300 ease-in-out",
  dropdownHidden: "hidden opacity-0",
};

function Header1() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [servicesDropdown, setServicesDropdown] = useState(false);
  const [loginDropdown, setLoginDropdown] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeSubcategory, setActiveSubcategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const activeCat = categories.find((cat) => cat.category_id === activeCategory);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupSubCategoryName, setPopupSubCategoryName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dropdownRef = useRef(null);
  const loginDropdownRef = useRef(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [selectedSubcategoryId, setSelectedSubcategoryId] = useState("");
  const [employeeName, setEmployeeName] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [profileImage, setProfileImage] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const employee = JSON.parse(localStorage.getItem('employee'));
    if (employee) {
      setEmployeeName(employee.name);
    }
    
    const customerData = JSON.parse(sessionStorage.getItem('customerData'));
    if (customerData) {
      setCustomerName(customerData.name);
    }

    const storedImage = sessionStorage.getItem('profileImage');
    if (storedImage) {
      setProfileImage(storedImage);
    }
  }, [location]);

  const handleLogout = () => {
    localStorage.removeItem('employee');
    setEmployeeName('');
    setLoginDropdown(false);
    navigate('/');
  };

  const handleCustomerLogout = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('customerData');
    setCustomerName('');
    setLoginDropdown(false);
    navigate('/');
  };

  const handleHomeClick = () => {
    navigate('/');
  };

  // Fetch Categories & Subcategories from API
  useEffect(() => {
    const fetchCategories = async () => {
      const data = await HeaderData();
      console.log('Fetched categories:', data);
      data.forEach(cat => console.log('Category name:', cat.category_name));
      if (data.success !== false) {
        setCategories(data);
      }
    };

    fetchCategories();
  }, []);

  // Handle scroll behavior for sticky header
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setServicesDropdown(false);
      }
      if (loginDropdownRef.current && !loginDropdownRef.current.contains(event.target)) {
        setLoginDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const openPopup = (subCategoryName, categoryId, subcategoryId) => {
    setPopupSubCategoryName(subCategoryName);
    setSelectedCategoryId(categoryId);
    setSelectedSubcategoryId(subcategoryId);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    let leadData = {
      name: event.target.name.value,
      email: event.target.email.value,
      mobile: event.target.contactNumber.value,
      category_id: selectedCategoryId ? Number(selectedCategoryId) : null,
      subcategory_id: selectedSubcategoryId ? Number(selectedSubcategoryId) : null,
    };

    try {
      const response = await postLead(leadData);
      setIsLoading(false);

      if (response.leadId) {
        toast.success(response.message);
        closePopup();
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      console.error("Error submitting lead:", error);
      toast.error("API request failed");
      setIsLoading(false);
    }
  };

  return (
    <>
      <header className={`${commonStyles.header} bg-darkBlue sticky top-0`}>
        <div className={`${commonStyles.container} grid grid-cols-2 md:grid-cols-3 items-center`}>
          <div className="flex-shrink-0 col-span-1">
            <a href="/" className={commonStyles.logo}>
              <img className="w-auto h-10 sm:h-14 object-contain" src={Logo1} alt="AuraUI Logo" />
            </a>
          </div>

          {/* Mobile Menu */}
          <div className="flex md:hidden justify-end col-span-1">
            <button onClick={() => setExpanded(!expanded)} className="text-white">
              {expanded ? <FiX className="w-6 h-6" /> : <FiMenu className="w-6 h-6" />}
            </button>
          </div>

          {/* Desktop Navbar */}
          <div className="hidden lg:flex lg:col-span-2 lg:items-center lg:justify-between">
            <div className="flex items-center space-x-12">
              <button onClick={handleHomeClick} className={commonStyles.navLink}>Home</button>
              <Link to="/about" className={commonStyles.navLink}>About</Link>
              <Link to="/blog" className={commonStyles.navLink}>Blog</Link>

              {/* Services Dropdown */}
              <div className="relative" ref={dropdownRef}>
                <button 
                  className={`${commonStyles.navLink} flex items-center`} 
                  onClick={() => setServicesDropdown(!servicesDropdown)}
                  onMouseEnter={() => setServicesDropdown(true)}
                >
                  Services
                  <FiChevronDown
                    className={`ml-1 w-5 h-5 transition-transform duration-300 ${servicesDropdown ? "rotate-180" : "rotate-0"}`}
                  />
                </button>

                {servicesDropdown && (
                  <div 
                    className="absolute left-1/2 top-full transform -translate-x-1/3 mt-6 flex w-[50vw] max-w-screen-lg p-4 rounded-md"
                    onMouseLeave={() => {
                      setServicesDropdown(false);
                      setActiveCategory(null);
                    }}
                  >
                    {/* Category List */}
                    <ul className="w-80 space-y-2 bg-darkBlue text-white overflow-y-auto p-4 text-[16px]">
                      {categories.filter(cat => cat.category_name?.toLowerCase() !== 'mutual funds' && cat.category_name?.toLowerCase() !== 'bond' && cat.category_name?.toLowerCase() !== 'credit cards' && cat.category_name?.toLowerCase() !== 'recruitment').map((category) => (
                        <li key={category.category_id}>
                          {category.subcategories.length > 0 ? (
                            <button
                              className={`flex items-center w-full text-left p-2 hover:bg-blue-900 ${activeCategory === category.category_id ? "bg-blue-900" : ""}`}
                              onMouseEnter={() => { setActiveCategory(category.category_id); setActiveSubcategory(null); }}
                              onClick={() => setActiveCategory(activeCategory === category.category_id ? null : category.category_id)}
                            >
                              {category.category_name} <FiChevronRight className="ml-auto" />
                            </button>
                          ) : (
                            <a
                              href={category.category_hyperlink ? category.category_hyperlink : '#'}
                              target={category.category_hyperlink ? "_blank" : "_self"}
                              className="block p-2 hover:bg-blue-900"
                              onMouseEnter={() => { setActiveCategory(null); setActiveSubcategory(null); }}
                              onClick={(e) => {
                                if (!category.category_hyperlink) {
                                  e.preventDefault();
                                  openPopup(category.category_name, category.category_id);
                                }
                              }}
                            >
                              {category.category_name}
                            </a>
                          )}
                        </li>
                      ))}

                      <li>
                        <button
                          className={`flex items-center w-full text-left p-2 hover:bg-blue-900 ${activeCategory === "mutual_funds" ? "bg-blue-900" : ""}`}
                          onMouseEnter={() => setActiveCategory("mutual_funds")}
                          onClick={() => setActiveCategory(activeCategory === "mutual_funds" ? null : "mutual_funds")}
                        >
                          Mutual Funds <FiChevronRight className="ml-auto" />
                        </button>
                      </li>

                    </ul>

                    {activeCategory && activeCat?.subcategories.length > 0 && (
                      <ul 
                        className="w-80 space-y-2 bg-blue-900 p-4 text-[14px] text-[#e6e6e6] overflow-y-auto"
                        onMouseEnter={() => setActiveCategory(activeCat.category_id)}
                      >
                        {activeCat?.subcategories.map((sub) => (
                          <li key={sub.subcategory_id}>
                            {sub.products && sub.products.length > 0 ? (
                              <button
                                className={`flex items-center w-full text-left p-2 hover:bg-blue-400 ${activeSubcategory === sub.subcategory_id ? "bg-blue-400" : ""}`}
                                onMouseEnter={() => setActiveSubcategory(sub.subcategory_id)}
                              >
                                {sub.sub_category_name} <FiChevronRight className="ml-auto" />
                              </button>
                            ) : (
                              <Link
                                to={`/services/product-details/${encryptID(sub.subcategory_id)}`}
                                target="_blank"
                                className="block p-2 hover:bg-blue-400"
                                onClick={() => setServicesDropdown(false)}
                              >
                                {sub.sub_category_name}
                              </Link>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}

                    {activeSubcategory && activeCat?.subcategories.find(s => s.subcategory_id === activeSubcategory)?.products.length > 0 && (
                      <ul 
                        className="w-80 space-y-2 bg-blue-800 p-4 text-[14px] text-[#e6e6e6] overflow-y-auto"
                        onMouseEnter={() => setActiveSubcategory(activeSubcategory)}
                      >
                        {activeCat?.subcategories.find(s => s.subcategory_id === activeSubcategory)?.products.map((product) => (
                          <li key={product.product_id}>
                            <Link
                              to={`/services/product-details/${encryptID(activeSubcategory)}?product=${product.product_id}`}
                              target="_blank"
                              className="block p-2 hover:bg-blue-600"
                              onClick={() => setServicesDropdown(false)}
                            >
                              {product.product_name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}

                    {activeCategory === "mutual_funds" && (
                      <ul 
                        className="w-80 space-y-2 bg-blue-900 p-4 text-[14px] text-[#e6e6e6] overflow-y-auto"
                        onMouseEnter={() => setActiveCategory("mutual_funds")}
                      >
                        <li className="font-semibold text-white">Calculators</li>
                        <li>
                          <Link to="/mutual-fund-calculator" className="block p-2 hover:bg-blue-400" onClick={() => setServicesDropdown(false)}>
                            Mutual Fund Calculator
                          </Link>
                        </li>
                        <li>
                          <Link to="/services/calculator/sip" className="block p-2 hover:bg-blue-400" onClick={() => setServicesDropdown(false)}>
                            SIP/LUMSUM
                          </Link>
                        </li>
                        <li>
                          <Link to="/services/calculator/swp" className="block p-2 hover:bg-blue-400" onClick={() => setServicesDropdown(false)}>
                            SWP
                          </Link>
                        </li>
                        <li className="font-semibold text-white">
                          <Link to="https://p.njw.bz/30915" target="_blank">
                          Create Account
                        </Link>
                        </li>
                      </ul>
                    )}
                  </div>
                )}
              </div>
              <Link to="/faqs" className={commonStyles.navLink}>FAQs</Link>
              <Link to="/careers" className={commonStyles.navLink}>Careers</Link>
              <Link to="/contact" className={commonStyles.navLink}>Contact Us</Link>
            </div>

            <div className="relative" ref={loginDropdownRef}>
              <button
                onClick={() => setLoginDropdown(!loginDropdown)}
                onMouseEnter={() => setLoginDropdown(true)}
                className="flex items-center text-white p-2 rounded-full hover:bg-blue-700 transition-all group relative"
              >
                {customerName && profileImage ? (
                  <div
                    className="w-10 h-10 rounded-full shadow-lg flex items-center justify-center border-2 border-white"
                    style={{
                      backgroundColor: '#f0f0f0'
                    }}
                  >
                    <img
                      src={profileImage}
                      alt="Profile"
                      className="w-full h-full rounded-full object-cover"
                    />
                  </div>
                ) : (
                  <span className="relative group/icon">
                    <FiUser className="w-6 h-6" />
                    {employeeName && (
                      <span className="absolute top-1/2 -translate-y-1/2 right-full mr-2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover/icon:opacity-100 transition-opacity whitespace-nowrap">
                        {employeeName}
                      </span>
                    )}
                    {customerName && (
                      <span className="absolute top-1/2 -translate-y-1/2 right-full mr-2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover/icon:opacity-100 transition-opacity whitespace-nowrap">
                        {customerName}
                      </span>
                    )}
                    {!employeeName && !customerName && (
                      <span className="absolute top-1/2 -translate-y-1/2 right-full mr-2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover/icon:opacity-100 transition-opacity whitespace-nowrap">
                        Login
                      </span>
                    )}
                  </span>
                )}
              </button>
              {loginDropdown && (
                <div 
                  className="absolute right-0 mt-2 w-40 bg-white shadow-lg rounded-md py-2 z-50"
                  onMouseLeave={() => setLoginDropdown(false)}
                >
                  {!employeeName && !customerName ? (
                    <>
                      <Link
                        to="/employee-login"
                        className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                        onClick={() => setLoginDropdown(false)}
                      >
                        Employee
                      </Link>
                      <Link
                        to="/customer-login"
                        className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                        onClick={() => setLoginDropdown(false)}
                      >
                        Customer
                      </Link>
                    </>
                  ) : employeeName ? (
                    <>
                      <Link
                        to="/employee-dashboard"
                        className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                        onClick={() => setLoginDropdown(false)}
                      >
                        Dashboard
                      </Link>
                      <button
                        onClick={handleLogout}
                        className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 flex items-center"
                      >
                        <FiLogOut className="mr-2" />
                        Logout
                      </button>
                    </>
                  ) : (
                    <>
                      <div className="px-4 py-2 text-gray-700 font-semibold">
                        {customerName}
                      </div>
                      <Link
                        to="/customer-profile"
                        className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                        onClick={() => setLoginDropdown(false)}
                      >
                        My Profile
                      </Link>
                      <button
                        onClick={handleCustomerLogout}
                        className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 flex items-center"
                      >
                        <FiLogOut className="mr-2" />
                        Logout
                      </button>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Navbar */}
      {expanded && (
        <nav className="bg-darkBlue !sticky top-0 px-4 py-20 md:hidden z-20">
          <ul className="space-y-4">

            <li>
              <button className={commonStyles.navLink}
                onClick={() => {
                  handleHomeClick();
                  setExpanded(false);
                }}
              >
                Home
              </button>
            </li>

            <li>
              <Link to="/about" className={commonStyles.navLink}
                onClick={() => {
                  setServicesDropdown(false);
                  setExpanded(false);
                }}
              >
                About
              </Link>
            </li>

            {/* Services Dropdown in Mobile */}
            <li>
              <button
                className={`${commonStyles.navLink} flex items-center`}
                onClick={() => setServicesDropdown(!servicesDropdown)}
              >
                Services <FiChevronRight className="ml-2" />
              </button>
              {servicesDropdown && (
                <div
                  className="pl-4 mt-2 space-y-4 bg-darkBlue rounded-md dropdown-debug"
                  style={{ zIndex: 999, position: 'relative' }}
                  ref={dropdownRef}
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* Manual addition of Mutual Funds */}
                  <div>
                    <button
                      className="flex items-center font-bold text-white text-[18px]"
                      onClick={() => setActiveCategory(activeCategory === "mutual_funds" ? null : "mutual_funds")}
                    >
                      Mutual Funds <FiChevronDown className="ml-2" />
                    </button>
                    {activeCategory === "mutual_funds" && (
                      <ul className="ml-4 space-y-2">
                        <li className="font-semibold text-white text-[18px]">Calculators</li>
                        <li>
                          <Link
                            to="/mutual-fund-calculator"
                            className={commonStyles.mobiledrop}
                            onClick={() => {
                              setActiveCategory(null);
                              setServicesDropdown(false);
                              setExpanded(false);
                            }}
                          >
                            Mutual Fund Calculator
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/services/calculator/sip"
                            className={commonStyles.mobiledrop}
                            onClick={() => {
                              setActiveCategory(null);
                              setServicesDropdown(false);
                              setExpanded(false);
                            }}
                          >
                            SIP/LUMSUM
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/services/calculator/swp"
                            className={commonStyles.mobiledrop}
                            onClick={() => {
                              setActiveCategory(null);
                              setServicesDropdown(false);
                              setExpanded(false);
                            }}
                          >
                            SWP
                          </Link>
                        </li>
                      </ul>
                    )}
                  </div>

                  {/* Loop through Categories and Subcategories */}
                  {categories.filter(cat => cat.category_name?.toLowerCase() !== 'mutual funds' && cat.category_name?.toLowerCase() !== 'bond' && cat.category_name?.toLowerCase() !== 'credit cards' && cat.category_name?.toLowerCase() !== 'recruitment').map((category) => (
                    <div key={category.category_id}>
                      {category.subcategories && category.subcategories.length > 0 ? (
                        <>
                          <button
                            className="flex items-center font-bold text-white text-[18px]"
                            onClick={() => setActiveCategory(activeCategory === category.category_id ? null : category.category_id)}
                          >
                            {category.category_name} <FiChevronDown className="ml-2" />
                          </button>
                          {activeCategory === category.category_id && (
                            <ul className="ml-4 space-y-2">
                              {category.subcategories.map((subcategory) => (
                                <li key={subcategory.sub_category_id}>
                                  <Link
                                    to={`/services/product-details/${subcategory.subcategory_id}`}
                                    target="_blank"
                                    className={commonStyles.mobiledrop}
                                    onClick={() => {
                                      setActiveCategory(null);
                                      setServicesDropdown(false);
                                      setExpanded(false);
                                    }}
                                  >
                                    {subcategory.sub_category_name}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          )}
                        </>
                      ) : (
                        <Link
                          to={category.path}
                          className="font-bold text-white text-[18px]"
                          onClick={() => {
                            setServicesDropdown(false);
                            setExpanded(false);
                          }}
                        >
                          {category.category_name}
                        </Link>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </li>

            <li>
              <Link to="/faqs" className={commonStyles.navLink}
                onClick={() => {
                  setServicesDropdown(false);
                  setExpanded(false);
                }}
              >
                FAQs
              </Link>
            </li>
            <li>
              <Link to="/careers" className={commonStyles.navLink}
                onClick={() => {
                  setServicesDropdown(false);
                  setExpanded(false);
                }}
              >
                Careers
              </Link>
            </li>
          </ul>

          <Link
            to="/contact"
            className={`${commonStyles.button} ${commonStyles.primaryButton}`}
            role="button"
            onClick={() => setExpanded(false)}
          >
            Contact Us
          </Link>
        </nav>
      )}

      {isPopupOpen && (
        <>

          {/* Transparent Background */}
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={closePopup}
          ></div>

          {/* Popup */}
          <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-11/12 max-w-3xl bg-white shadow-lg rounded-lg z-50 overflow-hidden flex flex-col md:flex-row">

            <button
              onClick={closePopup}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 text-xl"
            >
              ✖
            </button>

            {/* Left Side: Image */}
            <div className="w-full md:w-1/3 h-40 md:h-auto bg-cover bg-center" style={{ backgroundImage: `url(https://images.pexels.com/photos/7821911/pexels-photo-7821911.jpeg?auto=compress&cs=tinysrgb&w=600)` }}>
            </div>

            {/* Right Side: Form Content */}
            <div className="w-full md:w-2/3 p-4 md:p-6">
              <h2 className="text-xl md:text-2xl font-bold mb-2 md:mb-4">{popupSubCategoryName}</h2>
              <p className="text-gray-600 mb-4">Please fill out the form to buy this plan</p>
              <form onSubmit={handleFormSubmit} className="space-y-3 md:space-y-4">
                <div>
                  <label htmlFor="name" className="block font-medium text-gray-700">
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full border rounded-lg p-2 mt-1"
                    placeholder="Enter your full name"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block font-medium text-gray-700">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full border rounded-lg p-2 mt-1"
                    placeholder="Enter your email"
                  />
                </div>

                <div>
                  <label htmlFor="contactNumber" className="block font-medium text-gray-700">
                    Contact Number
                  </label>
                  <input
                    type="tel"
                    id="contactNumber"
                    name="contactNumber"
                    required
                    className="w-full border rounded-lg p-2 mt-1"
                    placeholder="Enter your contact number"
                  />
                </div>
                <div className="flex flex-col md:flex-row justify-end gap-2">
                  <button
                    type="button"
                    onClick={closePopup}
                    className="w-full md:w-auto px-4 py-2 border rounded-lg text-gray bg-skyBlue hover:bg-gray-100"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={isLoading}
                    className="w-full md:w-auto px-4 py-2 bg-darkBlue text-white rounded-lg"
                  >
                    Submit Application
                  </button>
                </div>
              </form>
            </div>
          </div>
        </>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default Header1;
